import { Component, Host, h, Prop, State, Watch, Event, type EventEmitter } from '@stencil/core';
import type { BooleanString } from '../../mobile-filters';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

@Component({
  tag: 'filters-chips-button-label',
  styleUrl: 'filters-chips-button-label.scss',
  shadow: true,
})
export class FiltersChipsButtonLabel {
  @Prop({attribute: 'chips-count'}) readonly chipsCountProp: string;
  @Prop({attribute: 'show-chips'}) readonly showChipsProp: BooleanString = 'false';
  @Prop({attribute: 'collapsed'}) readonly collapsedProp: BooleanString = 'false';
  @Prop() readonly labelProvider: labelProviderInterface;

  private chipsCount: number;
  private showCounter: boolean;
  private collapsed: boolean;

  @Event({bubbles: false}) clickOpenFilters: EventEmitter<void>;

  componentWillLoad(): void {
      this.chipsCount = parseInt(this.chipsCountProp);
      this.showCounter = this.showChipsProp === 'true';
      this.collapsed = this.collapsedProp === 'true';
  }

  componentWillUpdate() {
      this.chipsCount = parseInt(this.chipsCountProp);
      this.showCounter = this.showChipsProp === 'true';
      this.collapsed = this.collapsedProp === 'true';
  }

  render() {
      return (
        <Host
          onClick={() => this.clickOpenFilters.emit()}
          class={{
            'has-chips': (this.chipsCount && this.showCounter)
          }}>
          <span class={{
            'bc-label': true,
            'bold-label': this.collapsed
          }}>{this.labelProvider('mobile-filters.filter', 'Filter')}</span>
          <span class={`bc-counter ${(this.chipsCount && this.showCounter) ? 'visible' : ''} ${(this.chipsCount > 9) ? 'more-padding' : ''}`}>
            {this.chipsCount > 99 ? '99+' : this.chipsCount}
          </span>
        </Host>
      );
  }

}
